module.exports = __webpack_public_path__ + "static/Deel-ae69b5bc15a560fa3e01860315ad6c04.jpg";